import { ITheme, ThemeAddAction, ADD_THEMES } from './types'

export const addThemes = (themes: ITheme[]): ThemeAddAction => {
  return {
    type: ADD_THEMES,
    payload: themes,
  }
}
